module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/70257bec-d1be-475f-9255-97beeff66f82-d746b1a71c04704e3ed4ade5fce7e4fa.png";